export default __webpack_public_path__ + "static/media/add-objectives.429c8561.svg";